export default "__VITE_ASSET__4fa27f5f__"